import React from "react";
import {BannerType} from "../Banner/Banner";
import {Banner} from "../index";
import {ChildrenProps} from "../../../utils";

type Props = ChildrenProps;

const BannerWarning = ({children}: Props) => {
  return (
    <>
      <Banner type={BannerType.WARNING}>
        {children}
      </Banner>
    </>
  );
};

export default BannerWarning;